module.exports = __webpack_public_path__ + "static/media/kf-1.0f6cd6bf.jpeg";